import { render, staticRenderFns } from "./PlatformCell.vue?vue&type=template&id=6bc3df42"
import script from "./PlatformCell.vue?vue&type=script&lang=js"
export * from "./PlatformCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports